import { CompareTasks } from "event-definitions"
import { keyBy } from "lib/keyBy"
import { pick } from "lib/pick"
import { NewTask } from "routes/schedule/compare/new-task"
import { registerComparitor } from "routes/schedule/compare/register-comparitor"
import { RemovedTask } from "routes/schedule/compare/removed-task"
import { setAttributeFor } from "./register-task-comparitor"
import "./task-classification-comparitor"
import "./task-frequency-comparitor"
import { TaskHeaderBar } from "./task-header-bar"
import "./task-skill-comparitor"
import "./task-text-comparitor"
import "./task-uom-comparitor"
import { findTask } from "routes/schedule/compare/find-task"

registerComparitor("task-comparitor", ({ compare, to, target = {}, differences, comparedWith }) => {
    const compareTasks = keyBy(
        compare.tasks,
        pick((t) => t.taskId ?? t.id)
    )
    const toTasks = keyBy(
        to.tasks,
        pick((t) => t.taskId ?? t.id)
    )
    const targetTasks = keyBy(
        target?.tasks ?? [],
        pick((t) => t.taskId ?? t.id)
    )
    const comparedWithTasks = keyBy(
        comparedWith?.tasks ?? [],
        pick((t) => t.taskId ?? t.id)
    )

    for (const task of Object.values(compareTasks).sortBy("$sort")) {
        task.$name = compare.$name
        const otherTask = findTask(toTasks, task)
        const compareTask = findTask(comparedWithTasks, task)

        if (!otherTask && !compareTask) {
            differences.push(
                setAttributeFor(
                    <TaskHeaderBar task={task} compareFn={() => () => [false, false]} label={task.title}>
                        <NewTask id={task.id} task={task} />
                    </TaskHeaderBar>,
                    { compare: task, to: {}, target: task, comparedWith }
                )
            )
        } else {
            if (otherTask) {
                otherTask.$name = to.$name
            }
            CompareTasks.raise({
                differences,
                compare: task,
                comparedWith: compareTask,
                to: otherTask ?? compareTask,
                target: findTask(targetTasks, task) ?? task,
            })
            delete toTasks[(otherTask ?? compareTask ?? task)?.id]
            delete toTasks[(otherTask ?? compareTask ?? task)?.taskId]
            delete comparedWithTasks[(compareTask ?? otherTask ?? task)?.id]
            delete comparedWithTasks[(compareTask ?? otherTask ?? task)?.taskId]
        }
    }
    for (const task of Object.values(toTasks)) {
        differences.push(
            setAttributeFor(
                <TaskHeaderBar task={task} compareFn={() => () => [false, false]} label={task.title}>
                    <RemovedTask id={task.id} task={task} />
                </TaskHeaderBar>,
                { compare: {}, to: task, target: task, comparedWith }
            )
        )
    }
})
